import React from "react";
import { isMockApiEnabled } from "shared/api/client";
import styles from "./index.module.css";

/**
 * Permanent corner badge shown whenever the app is running on seeded mock
 * data (REACT_APP_USE_MOCK_API=true) instead of the real Admin API, so mock
 * results can never be mistaken for the real database. Renders nothing in
 * real-API mode (the default).
 */
export default function MockDataBadge() {
  if (!isMockApiEnabled()) return null;
  return (
    <div
      className={styles.badge}
      role="status"
      title="This build was started with REACT_APP_USE_MOCK_API=true. Everything you see is seeded demo data — nothing is read from or written to the real database."
    >
      <span className={styles.dot} aria-hidden="true" />
      MOCK DATA — not the real database
    </div>
  );
}
